var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNairaSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M416 256H384V72C384 49.906 366.094 32 344 32S304 49.906 304 72V256H271.756L137.5 50.156C127.844 35.344 109.625 28.625 92.594 33.656C75.625 38.688 64 54.312 64 72V256H32C14.312 256 0 270.312 0 288S14.312 320 32 320H64V440C64 462.094 81.906 480 104 480S144 462.094 144 440V320H217.986L310.5 461.844C318.031 473.375 330.75 480 344 480C347.781 480 351.625 479.469 355.406 478.344C372.375 473.312 384 457.688 384 440V320H416C433.688 320 448 305.688 448 288S433.688 256 416 256ZM144 256V206.562L176.244 256H144Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNairaSign);
export default __webpack_public_path__ + "static/media/naira-sign.356cdb566133cb7df40a56ba2ebf3ba7.svg";
export { ForwardRef as ReactComponent };